// 开发
// const baseUrl = "http://spmst.ubooking.cn/index";
// 斯平玛斯特
const baseUrl = "https://spmst.ubooking.cn/index";
export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js